export const TrustBlock = () => {
  return (
    <section className="bg-warm-white text-charcoal border-t border-charcoal/10">
      <div className="container-tight py-20 md:py-28 text-center">
        <p className="font-display text-2xl md:text-4xl leading-tight uppercase max-w-3xl mx-auto">
          We don't just remove debris.
          <br />
          <span className="text-brass-deep">We deliver finished environments.</span>
        </p>
      </div>
    </section>
  );
};
